const ipv4Regex =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const ipv6Regex = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}$/;

export class IPUtils {
  static isV4 = (ip: string): boolean => {
    return ipv4Regex.test(ip);
  };
  static isV6 = (ip: string): boolean => {
    return ipv6Regex.test(ip);
  };

  static compareIPs(ip1: string, ip2: string): number {
    const ipv6first = (this.isV4(ip1) ? this.ip4ToIp6(ip1) : ip1.trim()).split(':');
    const ipv6second = (this.isV4(ip2) ? this.ip4ToIp6(ip2) : ip2.trim()).split(':');
    for (let i = 0; i < 8; i++) {
      const first = parseInt(ipv6first[i], 16);
      const last = parseInt(ipv6second[i], 16);
      if (first < last) {
        return -1;
      } else if (first > last) {
        return 1;
      }
    }
    return 0;
  }

  static ip4ToIp6(rawIp: string): string {
    const ipv6Prefix = '0000:0000:0000:0000:0000:FFFF:';
    const nums = rawIp.split('.').map((n) => (+n).toString(16).padStart(2, '0'));
    const ipv4toHex = nums[0] + nums[1] + ':' + nums[2] + nums[3];

    return ipv6Prefix + ipv4toHex;
  }

  static isLocalIp(rawIp: string): boolean {
    return ['127.0.0.1', '::1'].includes(rawIp);
  }

  static containsIpInRange(rawIp: string, [start, finish]: string[]): boolean {
    return this.compareIPs(rawIp, start) > -1 && this.compareIPs(rawIp, finish) < 1;
  }
}
